import { Link } from "gatsby"
import React, { useState } from "react"
import { StaticImage } from "gatsby-plugin-image"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faFacebookF,
  faInstagram,
  faWhatsapp,
  faGoogle,
} from "@fortawesome/free-brands-svg-icons"

function Footer() {
  const [isOpen, setIsOpen] = useState(true)
  return (
    <footer className="z-50 grid  min-h-[30vh] w-full grid-cols-1 bg-bump-gray py-16 px-20 md:px-48 lg:grid-cols-2 lg:items-start lg:justify-between lg:py-32 lg:px-64">
      <div className="">
        <div className="flex ">
          <div className="my-auto h-auto w-16 lg:w-16">
            <StaticImage
              src="../images/bump-glyph-white.png"
              placeholder="blurred"
              layout="fullWidth"
              alt="BUMP Logo"
              quality="100"
            />
          </div>
          <div className="ml-2">
            <p className="font-Roboto text-xl font-bold text-bump-yellow md:text-2xl">
              Keep in touch
            </p>
            <div className="mt-2 flex items-baseline space-x-3 align-middle">
              <a
                href="https://www.facebook.com/bumpboulderingKL/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faFacebookF}
                  inverse
                  size="1x"
                  fill="fill-stone-100"
                />
              </a>

              <a
                href="https://www.instagram.com/bumpbouldering"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faInstagram}
                  inverse
                  size="lg"
                  fill="fill-stone-100"
                />
              </a>

              <a
                href="https://api.whatsapp.com/send?phone=60183604355"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faWhatsapp}
                  inverse
                  size="lg"
                  fill="fill-stone-100"
                />
              </a>

              <a
                href="mailto:hello@bumpbouldering.com?subject=Enquiry for Bump Bouldering&body=Hello, I have a question."
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faGoogle}
                  inverse
                  size="1x"
                  fill="fill-stone-100"
                />
              </a>
            </div>
          </div>
        </div>
        <div>
          <p className="mt-3 font-OpenSans text-xs font-light text-stone-100">
            © 2022 BUMP Bouldering by Uplift Climbing Sdn Bhd (1288936-M)
          </p>
        </div>
      </div>

      <div className="mt-8 lg:mx-auto lg:mt-0">
        <div className="flex flex-col  text-stone-100">
          <p className="font-Roboto text-xl font-bold text-bump-yellow md:text-2xl">
            Resources
          </p>
          <div className="flex-col space-y-1 font-OpenSans text-xs font-light md:text-sm">
            <Link to="/privacy-policy" className="block font-OpenSans">
              Privacy Policy
            </Link>
            <Link
              to="/terms-and-conditions"
              className="block font-OpenSans"
            >{`Terms & Conditions`}</Link>
            <Link
              to="/membership-policy"
              className="block font-OpenSans"
            >{`Freeze, Transference & Refund Policy`}</Link>
          </div>
        </div>

        {/* <div className="hidden flex-col text-stone-100 md:flex">
          <p className="font-Roboto text-xl font-bold text-bump-yellow md:text-2xl">
            Title
          </p>
          <div className="flex-col font-OpenSans text-xs font-light md:text-sm">
            <p className="font-OpenSans">Link</p>
            <p className="font-OpenSans">Link</p>
            <p className="font-OpenSans">Link</p>
          </div>
        </div>

        <div className="hidden flex-col text-stone-100 md:flex">
          <p className="font-Roboto text-xl font-bold text-bump-yellow md:text-2xl">
            Title
          </p>
          <div className="flex-col font-OpenSans text-xs font-light md:text-sm">
            <p className="font-OpenSans">Link</p>
            <p className="font-OpenSans">Link</p>
            <p className="font-OpenSans">Link</p>
          </div>
        </div> */}
      </div>
    </footer>
  )
}
export default Footer
